import { FormBuilder } from '@angular/forms';
import { KeyUsages } from 'src/app/shared/entities/key-usages';

export function buildKeyUsageGroup(
  fb: FormBuilder,
  initialValue?: {
    criticalKeyUsage?: boolean;
    keyUsages?: Partial<Record<KeyUsages, boolean>>;
  },
) {
  return fb.nonNullable.group({
    criticalKeyUsage: [!!initialValue?.criticalKeyUsage],
    keyUsages: fb.nonNullable.group({
      [KeyUsages.DIGITAL_SIGNATURE]: [
        !!initialValue?.keyUsages?.[KeyUsages.DIGITAL_SIGNATURE],
      ],
      [KeyUsages.NON_REPUDIATION]: [
        !!initialValue?.keyUsages?.[KeyUsages.NON_REPUDIATION],
      ],
      [KeyUsages.KEY_ENCIPHERMENT]: [
        !!initialValue?.keyUsages?.[KeyUsages.KEY_ENCIPHERMENT],
      ],
      [KeyUsages.DATA_ENCIPHERMENT]: [
        !!initialValue?.keyUsages?.[KeyUsages.DATA_ENCIPHERMENT],
      ],
      [KeyUsages.KEY_AGREEMENT]: [
        !!initialValue?.keyUsages?.[KeyUsages.KEY_AGREEMENT],
      ],
      [KeyUsages.KEY_CERT_SIGN]: [
        !!initialValue?.keyUsages?.[KeyUsages.KEY_CERT_SIGN],
      ],
      [KeyUsages.CRL_SIGN]: [!!initialValue?.keyUsages?.[KeyUsages.CRL_SIGN]],
      [KeyUsages.ENCIPHER_ONLY]: [
        !!initialValue?.keyUsages?.[KeyUsages.ENCIPHER_ONLY],
      ],
      [KeyUsages.DECIPHER_ONLY]: [
        !!initialValue?.keyUsages?.[KeyUsages.DECIPHER_ONLY],
      ],
    }),
  });
}

export interface KeyUsagesFormValue {
  criticalKeyUsage?: boolean;
  keyUsages?: Partial<Record<KeyUsages, boolean>>;
}

export function keyUsagesFormValueToDto(
  formValue: KeyUsagesFormValue | null | undefined,
): {
  criticalKeyUsage: boolean;
  keyUsages: KeyUsages[];
} {
  if (!formValue) {
    return {
      criticalKeyUsage: false,
      keyUsages: [],
    };
  }
  const criticalKeyUsage = !!formValue.criticalKeyUsage;
  const keyUsages = formValue.keyUsages ?? {};
  const keyUsagesArr: KeyUsages[] = [];
  Object.values(KeyUsages).forEach(keyUsage => {
    if (keyUsages[keyUsage]) {
      keyUsagesArr.push(keyUsage);
    }
  });
  return {
    criticalKeyUsage,
    keyUsages: keyUsagesArr,
  };
}

export function keyUsagesFormValueFromDto(dto: {
  criticalKeyUsage: boolean | null | undefined;
  keyUsages: string[] | null | undefined;
}): KeyUsagesFormValue {
  const criticalKeyUsage = !!dto.criticalKeyUsage;
  const keyUsages: Partial<Record<KeyUsages, boolean>> = {};
  Object.values(KeyUsages).forEach(usage => {
    keyUsages[usage] = !!dto.keyUsages?.includes(usage);
  });
  return { criticalKeyUsage, keyUsages };
}
